var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3225 18.4593C21.9286 18.1119 22.3002 17.4713 22.3002 16.7801V7.21996C22.3002 6.52872 21.9286 5.88813 21.3224 5.54073L12.9808 0.760708C12.3741 0.413097 11.6263 0.413097 11.0196 0.760706L2.67794 5.54074C2.07173 5.88812 1.7002 6.52871 1.7002 7.21996L1.7002 16.7801C1.7002 17.4713 2.07173 18.1119 2.67793 18.4593L11.0196 23.2393C11.0196 23.2393 11.0196 23.2393 11.0196 23.2393C11.6263 23.5869 12.3741 23.5869 12.9808 23.2393L21.3225 18.4593ZM21.3225 18.4593C21.3224 18.4593 21.3224 18.4593 21.3224 18.4593L12.9808 23.2393L21.3225 18.4593Z",
    stroke: "#0066FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2005 7.80714C15.9405 7.54714 15.5205 7.54714 15.2605 7.80714L12.0005 11.0605L8.74047 7.80047C8.48047 7.54047 8.06047 7.54047 7.80047 7.80047C7.54047 8.06047 7.54047 8.48047 7.80047 8.74047L11.0605 12.0005L7.80047 15.2605C7.54047 15.5205 7.54047 15.9405 7.80047 16.2005C8.06047 16.4605 8.48047 16.4605 8.74047 16.2005L12.0005 12.9405L15.2605 16.2005C15.5205 16.4605 15.9405 16.4605 16.2005 16.2005C16.4605 15.9405 16.4605 15.5205 16.2005 15.2605L12.9405 12.0005L16.2005 8.74047C16.4538 8.48714 16.4538 8.06047 16.2005 7.80714Z",
    fill: "#0066FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/reject-icon.ea67f4ab3ed4ea9bbefec9c6b9bdcb64.svg";
export { ForwardRef as ReactComponent };